var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"keyboardNumMini",class:_vm.keyboardClass})
}
var staticRenderFns = []

export { render, staticRenderFns }